export default __webpack_public_path__ + "static/media/LogoNova.9d113b7c.svg";